import { NgModule }              from '@angular/core';
import { NgbDropdownModule }     from '@ng-bootstrap/ng-bootstrap';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { CustomerMessagesCustomerListComponent }  from './customer-messages.customer-list.component';
import { CustomerMessagesMessageThreadComponent } from './customer-messages.message-thread.component';
import { CustomerMessagesNotificationsComponent } from './customer-messages.notifications.component';
import { CustomerMessagesSettingsComponent }      from './customer-messages.settings.component';
import { CustomerMessagesService }                from './customer-messages.service';
import { CustomerMessagesStates }                 from './customer-messages.states';
import { SharedModule }                           from '../../shared/shared.module';

@NgModule({
  declarations: [
    CustomerMessagesCustomerListComponent,
    CustomerMessagesMessageThreadComponent,
    CustomerMessagesNotificationsComponent,
    CustomerMessagesSettingsComponent
  ],
  entryComponents: [
    CustomerMessagesCustomerListComponent,
    CustomerMessagesMessageThreadComponent,
    CustomerMessagesNotificationsComponent,
    CustomerMessagesSettingsComponent
  ],
  exports: [
    CustomerMessagesCustomerListComponent,
    CustomerMessagesMessageThreadComponent,
    CustomerMessagesNotificationsComponent,
    CustomerMessagesSettingsComponent
  ],
  imports: [
    NgbDropdownModule,
    SharedModule,
    UIRouterUpgradeModule.forChild({ states: CustomerMessagesStates })
  ],
  providers: [
    CustomerMessagesService
  ]
})
export class CustomerMessagesModule {}